import axios from 'axios'

const directDepositsApiInstance = axios.create({
  baseURL: import.meta.env.VITE_DIRECT_DEPOSITS_API_BASE_URL
})

export default directDepositsApiInstance
